import GameCardUI from "./GameCardUI";
import card_back from "../../../images/gameplay_ui/cards/back/path_card_back.png";
import GameWindowHeader from "../GameWindowHeader";
import front_image from "../../../images/gameplay_ui/cards/path_image.png";
import front_image_2 from "../../../images/gameplay_ui/cards/card text.png";
import GameData from "../../../gameplay/model/GameData";
import {LOCO_HEADER_COLOR} from "../GameStyleUI";
export default class PathGameCardUI extends GameCardUI{

    render() {
        this.cardBack = card_back;
        let card = this.props.card;
        let styleFront= {
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            left: "0px",
            top: "0px",
            width: `${this.cardWidth}px`,
            height: `${this.cardHeight}px`,
            transform:`scale(${this.state.frontWidth}, ${this.state.backHeight})`,
            background: "#F2F2F2",
            borderRadius: "3px"
        }
        if(!this.props.card.isLucky){
            let path = GameData.CurrentGame.getPathByID(card.pathID);
            let colors = LOCO_HEADER_COLOR[path.locoType];
            this.contentCard = <div style={styleFront} onClick={this.hide.bind(this)} >
                <div style={{height:"10px"}}></div>
                <GameWindowHeader width={310}
                                  height={60}
                                  colorStart={colors[0]}
                                  colorEnd={colors[1]}
                                  title={`Путь ${card.pathID}`}
                                  fontSize={20}
                                  topPosition={10}
                />
                <img src={front_image} alt={"icon"}/>
                <img src={front_image_2} alt={"icon"}/>
            </div>
        }

        return super.render();
    }
}
